<div class="backgroundDialog" style="width: 100%;  height: 100%; padding: 0px;margin: auto; border: 5px solid rgb(207, 121, 1);">
  <div style="width: 100%; height: 100%; ">
    <form [formGroup]="formularioMonitoria" novalidate (ngSubmit)="add()">


    <table td style="width: 100%; z-index: 10000;">
      <tr>
          <td style="width: 30%;">
            <div style="text-align: center; width: 20%; " >
              <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                  background-color: rgb(46, 163, 80); font-size: 20px;">
                <label>&nbsp;&nbsp;Prévia do formulário&nbsp;</label>

              </mat-card>
            </div>
          </td>

          <td style="width: 40%; text-align: center;">
            <div style="font-weight: 500; color: white; font-size: 22px;">
              ID Ficha: &nbsp; {{beanMonitoria.moniIdCdMonitoria}}
            </div>
          </td>

          <td style="width: 20%; text-align: center;">

              <!-- <button mat-raised-button type="button"   (click)="atualizarMonitoriaEnviandoBeanCompleto()"
                      *ngIf="!isFinalizado ||
                              (beanMonitoria.moniDhFeedbackAvaliado == null && (tipoUsuarioLogado == 3 || tipoUsuarioLogado == 4) && formularioMonitoria.controls.txFeedback.value != '')
                             "



                  style="background-color: rgb(46, 163, 80); color: white; width: 90%; text-align: center;
                            height: 40px; font-size: 18px;margin-right: 20px; font-weight: normal; ">
                <img src="../../assets/img/icones/salvar.png" width="27px"> &nbsp; Salvar monitoria

              </button> -->

              <!-- <label  *ngIf="isFinalizado  && beanMonitoria.moniDhFeedbackAvaliado !=  null "
                style="color: white; width: 100%; text-align: center; margin-top: 25px;
                        height: 40px; font-size: 18px; margin-right: 20px; font-weight: normal; ">
                [ Encerrado ] Feedback Aplicado
              </label> -->
           </td>

          <td style="width: 06%; text-align: right;">
              <button (click)="sair()" mat-icon-button class="example-icon">
                <img src="../../assets/img/icones/cancel.png" width="40px">
              </button>
              &nbsp;&nbsp;&nbsp;
          </td>

      </tr>

    </table>



      <!--Definir o tamanho da tela-->
      <div style=" width: 100%; overflow:hidden; text-align: center; border-top: 5px solid rgb(207, 121, 1);">

        <div style="width: 100%; background-color: rgb(51, 68, 75); text-align: center;">

              <table style="width: 98%; margin-left: 10px;">
                <tr>
                  <td style="width: 100%;">
                    <table style="width: 100%; margin-top: 5px; text-align: left; font-size: 12px; ">
                      <tr>
                        <td style="width: 42%; color:white;">Operação: <b>Pluris Midia</b></td>
                        <td style="width: 23%; color:grey; text-align: center; " rowspan="4">
                          <div>
                            <table style="width: 100%;">
                              <tr>
                                <td style="width: 68%;">
                                        <div *ngIf="formularioMonitoria.controls.idFormulario.value > 0 " style="width: 100%; text-align: center;
                                            border: 5px solid rgb(248, 41, 110); background-color: rgb(252, 247, 242)" >
                                            <div
                                              style="width: 98%; margin: 0 auto; margin-top: 2px; color: white; font-weight: 500; font-size: 14px;
                                              background-color:rgb(248, 41, 110);  border: 2px solid rgb(82, 109, 121);  border-radius: 0px 0px 0px 0px">

                                              PONTUAÇÃO {{beanFormulario.formDsTipoPontuacao}}
                                            </div>

                                            <!-- <table style="width: 100%; margin-left: 3px;">
                                              <tr>
                                                <td style="width:20%; text-align: center; vertical-align: middle; ">

                                                    <div style="color:rgb(51, 68, 75);  ; font-size: 10px; cursor: pointer; font-weight: 500; background-color: white ;
                                                                  border-radius: 2px;   border: 1px solid black"
                                                      matTooltipPosition="above" matTooltip="Pontuação média">
                                                     {{formularioMonitoria.controls.nrPontuacaoNormal.value}}
                                                    </div>
                                                    <div style=" color: rgb(233, 186, 128); font-size: 10px; cursor: pointer; margin-top: 1px; font-weight: 500;
                                                                  border-radius: 2px; border: 1px solid black; background-color: rgb(139, 85, 18);"
                                                      matTooltipPosition="below" matTooltip="Pontuação Trunfo (perguntas com bônus extra média). *Exceto quando NC Grave.">
                                                       &nbsp;{{formularioMonitoria.controls.nrPontuacaoExtra.value}}
                                                    </div>
                                                </td>





                                                <td style="width:70%; text-align: center; vertical-align: middle;">
                                                  <input  matInput formControlName="nrPontuacao" [attr.disabled]="true" maxlength="3" readonly  placeholder=" - - "
                                                  style=" color: rgb(51, 68, 75); font-size: 25px; font-weight: bold; cursor: pointer;"  onchange="this.value = this.value.toUpperCase()">

                                                </td>
                                                <td style="width:10%; text-align: right; vertical-align: middle; ">
                                                  &nbsp;
                                                </td>

                                              </tr>
                                            </table> -->

                                            <input
                                              matInput value="---" [attr.disabled]="true" maxlength="3" readonly  placeholder=" - - "
                                              style=" color: rgb(51, 68, 75); font-size: 25px; font-weight: bold; cursor: pointer;"  onchange="this.value = this.value.toUpperCase()">

                                        </div>
                                        <mat-label style="color:white; font-size: 20px; padding-top: 3px;">VETERANO</mat-label>
                                  </td>
                                  <td style="width: 32%; vertical-align: top;">
                                    <div style="display: none;">
                                      <label *ngIf="qtdApontamentoNaoGrave > 0"   matTooltipPosition="right" matTooltip="Não confirmadade Basica"
                                        style="color: white; font-weight: bold; font-size: 14px; margin-top: 0px; margin-left: 0px;
                                                        background-color:rgb(207, 121, 1);  border: 2px solid rgb(207, 121, 1); border-radius: 20px 20px 20px 20px ">

                                        &nbsp;&nbsp;{{qtdApontamentoNaoGrave}}&nbsp;&nbsp;
                                      </label>&nbsp;&nbsp;
                                      <label *ngIf="qtdApontamentoNaoGrave > 0" matTooltipPosition="right"   matTooltip="Não confirmadade Basica"
                                        style="color: white; font-weight: 500; font-size: 12px; margin-top: 0px; margin-left: 0px;">
                                        NC Básica
                                      </label>
                                    </div>


                                    <div >&nbsp;&nbsp;
                                      <label *ngIf="qtdApontamentoGrave > 0"  matTooltipPosition="right" matTooltip="Não conformidade Grave"
                                        style="color: white; font-weight: bold; font-size: 14px; margin-top: 0px; margin-left: 0px;
                                                        background-color: rgb(248, 41, 110);  border: 2px solid rgb(248, 41, 110); border-radius: 20px 20px 20px 20px ">

                                        &nbsp;&nbsp;{{qtdApontamentoGrave}}&nbsp;&nbsp;
                                      </label>&nbsp;&nbsp;
                                      <label *ngIf="qtdApontamentoGrave > 0" matTooltipPosition="right" matTooltip="Não conformidade Grave"
                                        style="color: white; font-weight: 500; font-size: 12px; margin-top: 0px; margin-left: 0px;">
                                        NC Grave
                                      </label>
                                    </div>

                                </td>

                              </tr>

                            </table>
                          </div>

                        </td>
                        <td style="width: 35%; color:white; text-align: right; ">Inicio Ficha:<b> 01/01/2001 01:01</b></td>
                      </tr>
                      <tr>
                        <td style="color:white; overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          display: block;

                          width: calc(95%);">Avaliado: <b>Fulano</b></td>

                        <td style="width: 35%; color:white;  text-align: right;">
                            <div >
                              Feedback assinado em: <b>11/11/2011 11:11</b>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="color:white; overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          display: block;

                          width: calc(95%);">Gestor: <b>Ciclano</b></td>

                        <td style="width: 35%; color:white; text-align: right; " >Avaliador de produção: <b>Beltrano</b></td>
                      </tr>
                      <tr>
                        <td style="width: 42%; color:white; ">&nbsp;</td>

                        <td style="width: 35%; color:white; text-align: right; " >
                          Avaliador Regular: <b>Qualquer monitor</b>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

              </table>
        </div>
        <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

      </div>


      <table style="width: 100%; height: 50px; text-align: left;">
        <tr>
          <td style="width: 82%; color:white; vertical-align: middle; background-color: rgb(51, 68, 75);  ">


              <!-- ADICIONANDO UPLOAD DE ARQUIVO NA TELA DE LISTA ANEXOS - DANILLO 17/07/2023 -->
              <button mat-raised-button  style="outline: none; background-color: rgb(46, 163, 80); color:white; width: 80px; height: 40px; vertical-align: bottom; margin-left: 5px;  cursor: pointer;">
                <label style="outline: none; cursor: pointer; margin-left: -13px; margin-top: 10px; height: 100%; vertical-align: middle; ">
                    <mat-icon style="width: 18px;">attach_file</mat-icon>
                </label>

                <label style="outline: none; cursor: pointer; height: 100%; margin-left: 3.5px; vertical-align: middle; ">
                    Anexos
                </label>
              </button>

              <label style="outline: none; position: relative; left: -10px; top: -05px;">
                <button mat-mini-fab style="outline: none; background-color: rgb(207, 121, 1); color:white; width: 25px; height: 25px;">
                  <label style="margin-top: -6px; ">0</label>
                </button>
              </label>

              <mat-radio-group class="tp-radio-group" style="margin-left: 10px; vertical-align: bottom;">
                  <mat-radio-button class = "tp-radio-button" value="Inbound">Receptiva</mat-radio-button>
                  <mat-radio-button class = "tp-radio-button" value="Outbound">Ativa</mat-radio-button>
            </mat-radio-group>

              <button mat-mini-fab style="background-color: rgb(207, 121, 1) ; margin-left: 10px" class="upload-btn" [ngStyle] = "{'pointer-events':formContentDisabled}">
                  <mat-icon>add_call</mat-icon>
              </button>

              <span style="margin-left: 10px" matTooltipPosition="right" matTooltip="ID da chamada" readonly>Inum: 1234567890</span>



            <!-- ADICIONANDO UPLOAD DE ARQUIVO NA MONITORIA - RAFA 24/09/2022 -->
            <!--
            <input type="file" class="file-input" id="anexoMonitoria"
                [accept]="requiredFileType"
                (change)="onFileSelected($event, fileUpload)" #fileUpload style="display: none;">

            <div class="file-upload" style="vertical-align: bottom;">

              <button *ngIf="!contemAnexo && !isFinalizado"  mat-mini-fab style="background-color: rgb(207, 121, 1); width: 40px; height: 40px; " class="upload-btn"
                (click)="fileUpload.click()">
                  <mat-icon style="width: 25px;"> attach_file</mat-icon>
              </button>

              <button *ngIf="contemAnexo"  mat-mini-fab style="background-color: rgb(207, 121, 1);" class="upload-btn"
                (click)="downloadAnexo()">
                  <mat-icon>cloud_download</mat-icon>
              </button>

              &nbsp;
              {{fileName || "Sem arquivo anexo"}}


              <mat-radio-group *ngIf=" mogrDsInum == '' " class = "tp-radio-group" [(ngModel)]="tipoLigacao" [ngModelOptions]="{standalone: true}" style="margin-left: 5%;">
                <mat-radio-button class = "tp-radio-button"
                   *ngFor = "let tipo of tiposLigacao" [value] = "tipo">
                   {{tipo == 'Inbound' ? 'Receptiva' : 'Ativa'}}
                   &nbsp;
                </mat-radio-button>
             </mat-radio-group>

              <button *ngIf=" mogrDsInum == '' "  mat-mini-fab style="background-color: rgb(207, 121, 1);" class="upload-btn" [ngStyle] = "{'pointer-events':formContentDisabled}"
                (click)="gerarTagueamento()">
                  <mat-icon>add_call</mat-icon>
              </button>

              <span *ngIf=" mogrDsInum != '' " matTooltipPosition="right" matTooltip="ID da chamada" readonly>Inum: {{mogrDsInum}}</span>

                  <mat-icon  *ngIf="contemAnexo && !isFinalizado" style="color: rgb(248, 41, 110);  vertical-align: middle; cursor: pointer; font-weight: bold;"
                      (click)="deletarAnexo()">
                      close
                  </mat-icon>

            </div>
          -->
          </td>


          <td style="width: 17%; color:white; text-align: right; vertical-align: bottom; background-color: rgb(51, 68, 75); ">





              <img src="../../assets/img/icones/comentarioAlert.png" width="35px" matTooltip="Possui comentário"  matTooltipPosition="below">&nbsp;&nbsp;
              <img src="../../assets/img/icones/sireneVermelha.png" width="35px" matTooltip="Possui contestação"  matTooltipPosition="below"> &nbsp;&nbsp;
              <img src="../../assets/img/icones/impressora.png" width="30px"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </td>

        </tr>

      </table>
      <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(51, 68, 75);">&nbsp;</div>





      <div id="divContainerMonitoria" style="width: 100%;">

        <div id="divAdjustAutoHeightMonitoria" style="overflow-y: auto; border-bottom: 5px solid rgb(207, 121, 1);">

          <table style="width: 100%;  margin: auto; padding: 0px;  " >

                <tr>

                    <td style="width:100%; padding: 0px;  ">

                      <div style="background-color: lightgrey; padding: 0px; color: rgb(138, 138, 140); overflow: hidden;">

                        <table style="text-align: left; width: 97.5%; margin:auto; margin-bottom: 15px; margin-top: 15px;">

                          <tr>

                            <td style="width: 100%; font-size: 12px;" >


                              <div style="background-color: rgb(51, 68, 75); height: 25px; width: 99.8%; color: white; text-align: center;
                                          border-radius: 30px 30px 0px 0px; margin: auto; font-size: 16px;">
                                     Iniciar Formulário
                              </div>
                              <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px; margin-bottom: 15px;
                                                       background-color:rgb(207, 121, 1);" class="mat-elevation-z4">

                                <mat-card style="width: 100%; background-color:rgb(252, 247, 242); border: 1px solid rgb(51, 68, 75);
                                                    padding: 5px; margin-bottom: 10px;" class="mat-elevation-z4">

                                  <table style="width: 100%; margin-top: 15px;">
                                    <tr>
                                      <td style="width: 1%;" >&nbsp;</td>


                                      <td style="width: 35%;" [ngStyle] = "{'pointer-events':formIdFormularioDisabled}">

                                        <h5>{{beanFormulario.formDsFormulario}}</h5>
                                          <!-- <mat-form-field appearance="fill" style="width: 100%; font-size: 14px; font-weight: 500; text-align: center;">

                                            <mat-label>
                                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                              <b> Formulário</b>
                                              <i>(Ficha de monitoria)</i>
                                            </mat-label>
                                            <mat-select formControlName="idFormulario" (selectionChange)="onChangeMontarFormulario()"
                                                          style="text-align: center; font-size: 16px; font-weight: 500;">

                                                    <mat-option [value]="0">Selecione uma opção</mat-option>

                                                    <mat-option *ngFor="let colunas of lstCmbFormulario"
                                                                [value]="colunas.formIdCdFormulario">{{colunas.formDsFormulario}}
                                                    </mat-option>
                                            </mat-select>

                                          </mat-form-field> -->

                                      </td>
                                      <td style="width: 1%;" >&nbsp;</td>
                                      <td style="width: 35%;" [ngStyle] = "{'pointer-events':formContentDisabled}">

                                          <mat-form-field *ngIf="formularioMonitoria.controls.idFormulario.value > 0 "
                                                appearance="fill" style="width: 100%; font-size: 14px; font-weight: 500;  text-align: center;">
                                              <mat-label>
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Perfil</b>
                                                <i>(Obrigatório)</i>
                                              </mat-label>
                                              <mat-select formControlName="idPerfil"  style="text-align: center; font-size: 16px; font-weight: 500;">
                                                  <mat-option *ngFor="let colunas of lstCmbPerfil"
                                                            [value]="colunas.perfIdCdPerfil">{{colunas.perfDsPerfil}}
                                                </mat-option>
                                              </mat-select>
                                          </mat-form-field>

                                      </td>
                                      <td style="width: 1%;" >&nbsp;</td>
                                      <td style="width: 27%; vertical-align: top;"  [ngStyle] = "{'pointer-events':formStartDisabled}" >

                                        <!-- validar aparecer apenas se :  o id do form estiver preenchido > 0 e não existir idFormulario vindo do banco e o  form estiver bloqueado para edição (formStartDisabled = auto)
                                        <div *ngIf="formularioMonitoria.controls.idFormulario.value > 0 && beanMonitoria.formIdCdFormulario == null && formStartDisabled == 'auto' "
                                           style="width: 100%; vertical-align: top; margin: 0 auto" >

                                           <button mat-raised-button  type="button" *ngIf="isLiberarCriarFicha"
                                              style="background-color: rgb(46, 163, 80); color: #fff; vertical-align: top;
                                                      width: 100%;  height: 50px; font-size: 12px; " (click) ="salvarFichaMonitoria()">
                                            <img src="../../assets/img/icones/salvar.png" width="20px"> &nbsp;&nbsp;&nbsp;
                                            Criar Ficha de Monitoria
                                          </button>

                                        </div> -->

                                      </td>
                                    </tr>
                                  </table>

                                </mat-card>

                              </mat-card>











                              <div>

                                <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px;
                                        background-color:rgb(207, 121, 1);" class="mat-elevation-z4">

                                  <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75);
                                                    background-color:rgb(252, 247, 242); padding: 5px; margin-bottom: 10px;"
                                                    class="mat-elevation-z4">

                                    <div style="background-color: rgb(51, 68, 75); height: 25px; width: 99.9%; color: white; text-align: center;
                                                  border-radius: 03px 03px 03px 03px ; margin: 0 auto; font-size: 18px;">
                                        Cabeçalho padrão
                                    </div>

                                    <form [formGroup]="formularioMonitoria" [ngStyle] = "{'pointer-events':formContentDisabled}">

                                      <table style="width: 100%; padding: 0px; margin-top: 5px; margin-left: 5px;">

                                        <tr>
                                          <td style="width: 15%; vertical-align: top; ">

                                              <mat-form-field appearance="outline" style=" font-size: 12px;height: 55px;">

                                                  <mat-label style="font-weight: bold;">
                                                    <img src="../../assets/img/icones/setaDuplaDireita.png" width="20px">
                                                   Data do atendimento</mat-label>
                                                   <input matInput [matDatepicker]="picker" readonly formControlName="dsData">
                                                   <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                   <mat-datepicker #picker></mat-datepicker>

                                              </mat-form-field>


                                          </td>

                                          <td style="width: 10%; vertical-align: top;">

                                            <mat-form-field appearance="outline" style=" font-size: 12px;height: 55px;">

                                                <mat-label style="font-weight: bold;">
                                                  <img src="../../assets/img/icones/setaDuplaDireita.png" width="20px">
                                                 Hora do atendimento</mat-label>
                                                <input matInput formControlName="nrHora" type=time maxlength="200">

                                            </mat-form-field>


                                          </td>
                                          <td style="width: 75%; ">
                                            <mat-form-field  appearance="outline" >
                                              <mat-label>
                                                <img src="../../assets/img/icones/setaDuplaDireita.png" width="20px">
                                                Observação</mat-label>
                                              <textarea matInput rows="3"
                                                placeholder="Observação" style="white-space: pre-line;" formControlName="txObservacao">
                                              </textarea>
                                            </mat-form-field>
                                          </td>
                                        </tr>
                                      </table>

                                    </form>

                                  </mat-card>

                                </mat-card>

                              </div>

                              <br/>

                              <div *ngIf="formularioMonitoria.controls.idFormulario.value > 0 " >

                                <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px;
                                        background-color:rgb(207, 121, 1);" class="mat-elevation-z4">

                                  <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75);
                                                      background-color:rgb(252, 247, 242); padding: 5px; margin-bottom: 10px;"
                                                      class="mat-elevation-z4">

                                    <div style="background-color: rgb(51, 68, 75); height: 25px; width: 99.9%; color: white; text-align: center;
                                                border-radius: 03px 03px 03px 03px ; margin: 0 auto; font-size: 18px;">
                                        Cabeçalho (Parâmetros do formulário)
                                    </div>
                                    <br/>
                                    <form [formGroup]="formCabecalho" [ngStyle] = "{'pointer-events':formContentDisabled}">


                                      <table style="width: 100%; padding: 0px; margin-top: 10px;">

                                        <tr  *ngFor="let formField of formFieldsCabecalho">
                                          <td style="width: 48%;" [hidden]="formField.paraDhInativo != null">

                                              <!--Cabeçalho noral sem o motivo-->
                                              <mat-form-field *ngIf="formField.beanParametroXMotivo.length == 0"
                                                  appearance="outline" style=" font-size: 12px;height: 55px;">

                                                  <mat-label style="font-weight: bold;">
                                                    <img src="../../assets/img/icones/setaDuplaDireita.png" width="20px">
                                                    {{formField.paraDsParametro}} {{formField.pamoIdCdParametroFormulario == 0 ? '' : '&#x2714;' }}</mat-label>
                                                  <input matInput formControlName="{{formField.pamoIdCdParametroFormulario > 0 ? formField.pamoIdCdParametroFormulario:''}}{{formField.pamoIdCdParametroFormulario > 0 ? ':' : ''}}{{formField.paraIdCdParametro}}" maxlength="600" onchange="this.value = this.value.toUpperCase()">

                                              </mat-form-field>


                                          </td>
                                        </tr>

                                      </table>







                                        <table style="width: 100%; padding: 0px; margin-top: 10px; " *ngIf="marcadorCabecalhoMotivo">

                                          <tr>
                                            <td>

                                              <div style="background-color: rgb(51, 68, 75); height: 25px; width:30%; color: white; text-align: center;
                                                            border-radius: 30px 30px 0px 0px; margin: auto; font-size: 16px;">
                                                  Cabeçalhos com motivos
                                              </div>

                                            </td>

                                          </tr>
                                          <tr  *ngFor="let formField of formFieldsCabecalho">
                                            <td style="width: 48%; ">

                                                <!--Cabeçalho possui campos de motivo-->

                                                <mat-form-field *ngIf="formField.beanParametroXMotivo.length > 0" (click)="loadDialogParametroMotivos(formField)"
                                                    appearance="outline" style=" font-size: 12px;height: 55px;" [attr.readonly]="true">

                                                    <mat-label style="font-weight: bold;">
                                                      <img src="../../assets/img/icones/setaDuplaDireita.png" width="20px">
                                                      {{formField.paraDsParametro}} {{formField.pamoIdCdParametroFormulario == 0 ? '' : '&#x2714;' }} <label style="color: rgb(190, 190, 190);">[ CLIQUE NO CAMPO PARA ADICIONAR O(S) MOTIVO(S) ]</label></mat-label>
                                                      <input matInput  formControlName="{{formField.pamoIdCdParametroFormulario > 0 ? formField.pamoIdCdParametroFormulario:''}}{{formField.pamoIdCdParametroFormulario > 0 ? ':' : ''}}{{formField.paraIdCdParametro}}" maxlength="600" onchange="this.value = this.value.toUpperCase()">

                                                </mat-form-field>

                                            </td>
                                          </tr>


                                        </table>

                                    </form>

                                    <br/>

                                  </mat-card>

                                </mat-card>
                              </div>








                            </td>
                          </tr>

                        </table>

                        <table style="text-align: left; width: 97.5%; margin:auto; margin-bottom: 15px; margin-top: 15px;">
                          <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px;
                            background-color:rgb(207, 121, 1);" class="mat-elevation-z4">

                            <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75);
                              background-color:rgb(252, 247, 242); padding: 5px; margin-bottom: 10px;"
                              class="mat-elevation-z4">


                              <div style="background-color: rgb(51, 68, 75); height: 25px; width: 99.9%; color: white; text-align: center;
                                border-radius: 03px 03px 03px 03px ; margin: 0 auto; font-size: 18px;">
                                Questionário
                              </div>

                              <table *ngIf="formularioMonitoria.controls.idFormulario.value > 0 "
                                style="text-align: left; width: 97.5%; height: 98%; margin:auto; margin-top: 30px;">

                                <tr>

                                  <td style="width: 100%; height: 100%;" >

                                    <div  style="font-size: 12px; color: white; height: 100%;">

                                      <!--QUESTIONARIO ACCORDEON -->
                                      <div class="accordion" id="accordionParentQuestionario">

                                        <div *ngFor="let grupoCategoriaList of beanFormulario.categoryGroups"  >



                                            <div class="card" *ngFor="let categoriaList of grupoCategoriaList.categories"
                                                    [hidden]="grupoCategoriaList.grcaDhInativo != null || categoriaList.cateDhInativo != null" >


                                              <!-- GRUPO - CATEGORIA -->
                                              <div id="{{'head-'+grupoCategoriaList.grcaIdCdGrupoCategoria+'_'+categoriaList.cateIdCdCategoria}}" >

                                                  <div class="row">

                                                    <div class="col-12 bg-secondary mb-0" style=" z-index: 10" >
                                                      <button class="btn btn-block text-left collapsed" style="color: white; "  type="button" data-toggle="collapse"
                                                              [attr.data-target]="'#collapseQuestion'+grupoCategoriaList.grcaIdCdGrupoCategoria+'_'+categoriaList.cateIdCdCategoria"
                                                              [attr.aria-controls]="'collapseQuestion'+grupoCategoriaList.grcaIdCdGrupoCategoria+'_'+categoriaList.cateIdCdCategoria"
                                                              aria-expanded="false" >

                                                            {{grupoCategoriaList.grcaDsGrupoCategoria}}  &nbsp;  - &nbsp;  {{categoriaList.cateDsCategoria}}

                                                            <!--MAPEAMENTO-->
                                                            <label  style="position: absolute; top: 1.5px; right: 07px; margin-top: 5px;">

                                                              <label matTooltipPosition="above" matTooltip="Não conformidade Grave"
                                                                style="color: rgb(255, 255, 255); border: 1px solid white; font-weight: 500; font-size: 14px; margin-left: 10px;"
                                                                *ngIf="grupoCategoriaList.grcaInMapeamento=='S'" matTooltip="Grupo de categoria Mapeamento : Não será contabilizado na nota final. Excluindo casos de Não Conformidade Grave [NCG].">

                                                                &nbsp; M &nbsp;
                                                              </label>

                                                            </label>






                                                      </button>

                                                    </div>

                                  <!--                  <div class="col-2 bg-info "
                                                          style="vertical-align: middle;
                                                                  z-index: 10">



                                                      <label style="position: absolute; top: 07px; left: 07px;  text-align: right;">
                                                          <label matTooltipPosition="above" matTooltip="Não conformidade Grave"
                                                            style="color: rgb(255, 255, 255); border: 1px solid white; font-weight: 500;
                                                                  font-size: 14px; width: 60px;" matTooltip="Pontuação total do grupo">

                                                              <label *ngIf="grupoCategoriaList.grcaInMapeamento=='S'"> - -</label>
                                                              &nbsp; -- Pts &nbsp;
                                                          </label>
                                                      </label>

                                                      <label hidden style="margin-top: 3px; font-size: 18px;">
                                                        <img src="../../assets/img/icones/comentarioAlert.png"  width="25px">
                                                      </label>
                                                      <label hidden matTooltipPosition="above" matTooltip="Não conformidade Grave"
                                                        style="color: rgb(255, 255, 255); border: 1px solid white; font-weight: 500; font-size: 14px; margin-left: 10px;">
                                                        &nbsp;NCG&nbsp;
                                                      </label>
                                                      <label hidden style="margin-left: 10px; font-size: 18px;">
                                                        <img src="../../assets/img/icones/sireneVermelha.png" width="25px" >
                                                      </label>

                                                    </div>-->

                                                  </div>

                                              </div>



                                              <!-- PERGUNTAS E RESPOSTAS -->
                                              <div style="color: rgb(73, 73, 73); background-color: rgb(240, 240, 240)
                                                      ; border-bottom : 0.5px solid rgb(82, 82, 82)
                                                      ; border-left : 0.5px solid rgb(82, 82, 82)
                                                      ; border-right : 0.5px solid rgb(82, 82, 82)
                                                      ;margin-bottom: 15px; margin-top: -7px; margin-right: 10px; z-index: 0;"
                                                    id="{{'collapseQuestion'+grupoCategoriaList.grcaIdCdGrupoCategoria+'_'+categoriaList.cateIdCdCategoria}}" class="collapse multi-collapse"

                                                    >

                                                  <div class="card-body" style="padding: 0; margin: 0;">



                                                    <!--
                                                      {{beanCategoryColapse[0].questions | json }}
                                                    -->

                                                    <div *ngFor="let perguntasList of categoriaList.questions"
                                                        style="width: 100%;" [ngStyle] = "{'pointer-events':formContentDisabled}">

                                                        <div *ngIf="perguntasList.pergInExtra=='S' && perguntasList.questionAnswers.length > 0"
                                                          style="position: absolute; left: 0px; color: rgb(233, 186, 128);font-weight: bold; width: 15px; background-color: rgb(139, 85, 18);;
                                                                  font-family: Generic Font Family, Times, serif; padding:0px; font-size: 11px; text-align: center;
                                                                  border: 0.5px solid black">

                                                          T<br/>R<br/>U<br/>N<br/>F<br/>O
                                                        </div>


                                                      <div *ngIf="perguntasList.questionAnswers.length > 0" [ngClass]="{'perguntaTrunfo': perguntasList.pergInExtra=='S' }"  >

                                                        <table style="width: 100%; text-align: left; position: absolute; margin-top: 70px;" >
                                                          <tr>
                                                            <td style="width: 85%;">&nbsp;&nbsp;</td>
                                                            <td style="width: 15%;">
                                                              <table style="width: 100%;">
                                                                <tr>
                                                                  <td>
                                                                    <div class="imgCommented" *ngIf="perguntasList.isCommented;" [ngStyle]="{'pointer-events': 'auto' }" style="margin-top: -25px; text-align: right; cursor: pointer;">
                                                                      <img src="../../assets/img/icones/comentarioAlert.png" width="33px">
                                                                    </div>
                                                                    <div class="imgCommented" *ngIf="!perguntasList.isCommented;" [ngStyle]="{'pointer-events':'auto' }" style="margin-top: -25px; text-align: right; cursor: pointer;">
                                                                      <img src="../../assets/img/icones/comentario.png" width="33px">
                                                                    </div>
                                                                  </td>
                                                                  <td>
                                                                    <div class="imgCommented" *ngIf="perguntasList.isContested;" [ngStyle]="{'pointer-events':  'auto' }" style="margin-top: -24px; text-align: center; cursor: pointer;">
                                                                      <img src="../../assets/img/icones/sireneVermelha.png" width="33px" style="text-align: center">
                                                                    </div>
                                                                    <div class="imgCommented" *ngIf="!perguntasList.isContested;" [ngStyle]="{'pointer-events':  'auto' }" style="margin-top: -24px; text-align: center; cursor: pointer; ">
                                                                      <img src="../../assets/img/icones/check.png" width="28px" style=" text-align: center">
                                                                    </div>
                                                                  </td>
                                                                  <td>
                                                                    &nbsp;
                                                                  </td>
                                                                </tr>
                                                              </table>

                                                            </td>
                                                          </tr>
                                                        </table>
                                                        <table style="width: 100%; text-align: left;" >
                                                          <tr>
                                                            <td style="width: 100%;font-weight: 500;">


                                                              <table style="width: 100%;" >
                                                                <tr>

                                                                  <td style="width: 100%; margin-top:-5px; ">
                                                                    <br/> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                                          <label matTooltip="{{perguntasList.pergDsObservacao}}" id="question" style="cursor: pointer; font-size: 15px; width: 90%;"
                                                                                [ngStyle]="{'pointer-events':'auto' }" matTooltipClass="example-tooltip-green" matTooltipPosition="after"
                                                                                (click)="loadDialogObservacao(perguntasList.pergDsObservacao)">
                                                                                    <img matTooltip="{{perguntasList.pergDsObservacao}}" style="cursor: pointer;" [ngStyle]="{'pointer-events':'auto' }" matTooltipClass="example-tooltip-green" matTooltipPosition="after" src="../../assets/img/icones/info.png" width="19px" (click)="loadDialogObservacao(perguntasList.pergDsObservacao)">
                                                                                    &nbsp;  {{perguntasList.pergDsPergunta}}
                                                                            </label>
                                                                  </td>
                                                                  <td style="width: 15%;">
                                                                    &nbsp;
                                                                  </td>
                                                                </tr>
                                                              </table>






                                                            </td>
                                                          </tr>
                                                          <tr>
                                                            <td style="width: 100%; ">



                                                              <table style="width: 100%; " >
                                                                <tr>
                                                                  <td style="width: 99%;">


                                                                      <!--RESPOSTA-->
                                                                      <mat-radio-group>

                                                                        <mat-radio-button  *ngFor="let perguntsRespostasList of perguntasList.questionAnswers;"
                                                                                style="vertical-align: top; margin-left: 20px;"
                                                                                value="{{perguntsRespostasList.answer.respIdCdResposta}}" checked="{{perguntsRespostasList.pereInRespostaDefault == 'S' ? true : false}}">


                                                                                      <!--{{perguntsRespostasList | json}}-->


                                                                                      <!-- RESPOSTA -->
                                                                                      <label style="margin-left: -27px; border-bottom: 2px solid grey; border-bottom-left-radius: 9px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                        {{perguntsRespostasList != undefined ? perguntsRespostasList.answer.respDsResposta : ''}} &nbsp;
                                                                                      </label>

                                                                                      <!-- QUANDO PONTOS -->
                                                                                      <label *ngIf="perguntsRespostasList != undefined && perguntsRespostasList.pereNrPontoExtra == '' || perguntsRespostasList.pereNrPontoExtra == null "
                                                                                      [ngClass]="{'caixaPontoPositivo': perguntsRespostasList.pereInZerar != 'S' ,
                                                                                                  'caixaPontoMapeamento': perguntsRespostasList.pereInZerar == 'S' || perguntsRespostasList.respInNaoseaplica == 'S',
                                                                                                  'caixaPontoNaoAplicavel': perguntsRespostasList.answer.respInNaoseaplica == 'S' }"
                                                                                                    matTooltipPosition="above" matTooltip="{{perguntsRespostasList.answer.respInNaoseaplica != 'S' ? 'Adicionado ao cálculo da pontuação.': 'Não adicionada ao cálculo da pontuação'}}">




                                                                                                              &nbsp;
                                                                                                              {{
                                                                                                                perguntsRespostasList != undefined ?
                                                                                                                    perguntsRespostasList.answer.respInNaoseaplica == 'S' ? 'NA' :
                                                                                                                      perguntsRespostasList.pereInZerar == 'S' ? 'XX' :
                                                                                                                        perguntsRespostasList.pereNrPonto < 10 ? "0"+perguntsRespostasList.pereNrPonto :
                                                                                                                          perguntsRespostasList.pereNrPonto  :
                                                                                                                ''}}

                                                                                                              &nbsp;





                                                                                      </label>

                                                                                      <!-- QUANDO PONTOS EXTRAS (TRUNFO) -->
                                                                                      <label *ngIf="grupoCategoriaList.grcaInMapeamento!='S' && perguntsRespostasList != undefined && perguntsRespostasList.pereNrPontoExtra != '' && perguntsRespostasList.pereNrPontoExtra != null "
                                                                                                  matTooltipPosition="below" matTooltip="Pontuação extra: Adicionado ao resultado final da pontuação média."
                                                                                                  [ngClass]="{'caixaPontoPositivo': perguntsRespostasList.pereNrPontoExtra >= 0, 'caixaPontoNegativo': perguntsRespostasList.pereNrPontoExtra < 0 || perguntsRespostasList.pereInZerar == 'S'  }"  >


                                                                                                    &nbsp;&nbsp; &nbsp;{{perguntsRespostasList != undefined ? perguntsRespostasList.pereNrPontoExtra : ''}}

                                                                                        &nbsp;
                                                                                      </label>

                                                                                      <!-- QUANDO PONTOS EXTRAS (TRUNFO) -->
                                                                                      <label *ngIf="grupoCategoriaList.grcaInMapeamento=='S'"
                                                                                                    matTooltipPosition="below" matTooltip="Grupo de categoria [Mapeamento] não se aplica pontos."
                                                                                                      class="caixaPontoMapeamento">
                                                                                          &nbsp; NA

                                                                                        &nbsp;
                                                                                      </label>


                                                                                      &nbsp;&nbsp;&nbsp;
                                                                        </mat-radio-button>

                                                                      </mat-radio-group>
                                                                  </td>
                                                                  <td style="width: 1%;">
                                                                    &nbsp;
                                                                  </td>
                                                                </tr>
                                                              </table>



                                                            <div *ngIf="perguntasList.isCommented;"  style="width: 100%; margin-top: 15px; ">

                                                              <table style="width: 100%;" >
                                                                <tr>
                                                                  <td style="width: 1%;">
                                                                    &nbsp;
                                                                  </td>
                                                                  <td style="width: 98%;">

                                                                    <div style="background-color: rgb(230, 237, 248) ; color: black;
                                                                                border: grey 1px dashed;
                                                                                border-radius: 5px 5px 5px 5px;

                                                                                ">

                                                                          <label style="font-weight: 500; text-align: right; margin-top: 10px; margin-left: 10px;">
                                                                              COMENTÁRIO AVALIADOR:
                                                                          </label>
                                                                          <br/>

                                                                          <textarea matInput readonly cdkTextareaAutosize  style="white-space: pre-line; overflow: hidden; margin-left: 10px;"
                                                                          [ngStyle]="{'pointer-events':'auto' }"  ></textarea>

                                                                          <br/><br/>


                                                                    </div>
                                                                  </td>
                                                                  <td style="width: 1%;">
                                                                    &nbsp;
                                                                  </td>
                                                                </tr>
                                                              </table>
                                                              <br/>
                                                            </div>


                                                            <div style="width: 100%; border-bottom: 1px solid rgb(194, 194, 194); margin-bottom: 0px;"></div>


                                                            </td>
                                                          </tr>

                                                        </table>



                                                      </div>

                                                  </div>

                                                </div>
                                              </div>

                                            </div>
                                          </div>
                                        </div>


                                    </div>
                                  </td>
                                </tr>

                              </table>
                              <br/>
                            </mat-card>
                          </mat-card>
                        </table>

                        <table  *ngIf="formularioMonitoria.controls.idFormulario.value > 0 "
                             style="text-align: left; width: 97.5%; height: 98%; margin:auto; margin-top: 20px;">
                          <tr>
                            <td style="width: 100%; height: 100%;" >
                              <div  style="font-size: 12px; height: 100%;">

                                <table style="text-align: left; width: 100%; margin-top: 20px;"  [ngStyle] = "{'pointer-events':formContentDisabled}">

                                  <tr>

                                    <td style="width: 100%; " >

                                        <div style="background-color: rgb(51, 68, 75); height: 25px; width: 99.8%; color: white; text-align: center;
                                                      border-radius: 30px 30px 0px 0px; font-size: 16px;">
                                          Conteúdo Global
                                        </div>

                                        <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px; margin-bottom: 15px;
                                                background-color:rgb(207, 121, 1); " class="mat-elevation-z4">

                                          <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); background-color:rgb(252, 247, 242); padding: 8; margin-bottom: 10px;" class="mat-elevation-z4">

                                            <table style="width: 100%;">
                                              <tr>
                                                <td style="width: 25%; ">

                                                <mat-form-field appearance="fill" style="width: 100%; font-size: 14px; font-weight: 500;">

                                                    <mat-label style="text-align: left;">
                                                      <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                      <b> Status</b>
                                                    </mat-label>
                                                    <mat-select formControlName="statIdCdStatus"
                                                                  style="text-align: center; font-size: 16px; font-weight: 500;">

                                                            <!--<mat-option [value]="0">Selecione uma opção</mat-option>-->

                                                            <mat-option *ngFor="let colunas of lstCmbStatus"
                                                                        [value]="colunas.statIdCdStatus">{{colunas.statDsStatus}}
                                                            </mat-option>
                                                    </mat-select>

                                                  </mat-form-field>

                                                </td>
                                                <td style="width: 25%;  text-align: left; vertical-align: top;">

                                                    <!-- <div style="width: 100%; vertical-align: middle; height: 50px;" *ngIf="!isFinalizado" >
                                                      <button mat-raised-button  type="button" (click)="vincularStatusMonitory()"
                                                              style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px; height: 50px;">
                                                        Vincular novo status
                                                      </button>
                                                    </div> -->

                                                </td>
                                                <td style="width: 50%;">&nbsp;</td>

                                              </tr>

                                            </table>


                                            <table style="width: 100%; background-color: rgb(51, 68, 75); text-align: left;" >
                                              <tr>
                                                <td style="width: 33%; color: white;">
                                                  &nbsp;&nbsp;Status:
                                                </td>
                                                <td style="width: 33%; color: white;">
                                                  Usuario:
                                                </td>
                                                <td style="width: 33%; color: white;">
                                                  Data do registo:
                                                </td>
                                              </tr>
                                            </table>


                                            <!-- <table *ngFor="let statusMonitory of lstBeanStatusMonitory" style="width: 100%; text-align: left;" >
                                              <tr style="border-bottom: 1px solid grey;">
                                                <td style="width: 33%;">
                                                  &nbsp;&nbsp;{{statusMonitory.status.statDsStatus}}
                                                </td>
                                                <td style="width: 33%;">
                                                  {{statusMonitory.user.usuaNmUsuario}}
                                                </td>
                                                <td style="width: 33%;">
                                                  {{statusMonitory.stmoDhRegistro}}
                                                </td>
                                              </tr>
                                            </table> -->



                                          </mat-card>

                                        </mat-card>

                                    </td>

                                  </tr>

                                </table>

                                <table style="text-align: left; width: 100%; margin-top: 20px; " [ngStyle] = "{'pointer-events':formContentDisabled}">

                                  <tr>

                                    <td style="width: 100%; " >

                                        <div style="background-color: rgb(51, 68, 75); height: 25px; width: 99.8%; color: white; text-align: center;
                                                      border-radius: 30px 30px 0px 0px; font-size: 16px;">
                                          Comentarios e Encerramento
                                        </div>

                                        <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px;
                                                background-color:rgb(207, 121, 1);" class="mat-elevation-z4">


                                          <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 8; background-color:rgb(252, 247, 242);" class="mat-elevation-z4">

                                            <table style="width: 100%; background-color: rgb(51, 68, 75); text-align: left;" >
                                              <tr>
                                                <td style="width: 100%; color: white; text-align: center;">
                                                  Avaliador
                                                </td>
                                              </tr>
                                            </table>

                                            <table style="width: 100%; margin-top: 15px;">
                                              <tr>
                                                <td style="width: 95%; ">
                                                  <mat-form-field  appearance="outline" >
                                                    <mat-label>
                                                      <img src="../../assets/img/icones/avaliadora.png" width="25px">
                                                      Avaliador</mat-label>
                                                    <textarea matInput rows="5"
                                                      placeholder="Descrição do Avaliador" style="white-space: pre-line;" [ngStyle]="{'pointer-events':'auto' }"  formControlName="txAvaliador"></textarea>
                                                  </mat-form-field>
                                                </td>
                                                <!-- <td style="width: 05%; vertical-align: top; ">
                                                  <button mat-raised-button  type="button" (click)="atualizarMonitoriaEnviandoCampo('txAvaliador')"
                                                      style="background-color: rgb(46, 163, 80); color: #fff; vertical-align: top;
                                                              width: 100%;  font-size: 12px; margin-top: 5px">
                                                          <img src="../../assets/img/icones/salvar.png" width="20px">
                                                    </button>
                                                </td> -->
                                              </tr>
                                            </table>

                                          </mat-card>

                                          <mat-card   [ngStyle] = "{'pointer-events': beanMonitoria.moniDhFeedbackAvaliado == null ? 'auto' : 'none'}"
                                                      style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 8; margin-top: 20px; background-color:rgb(252, 247, 242);" class="mat-elevation-z4">

                                            <table style="width: 100%; background-color: rgb(51, 68, 75); text-align: left;" >
                                              <tr>
                                                <td style="width: 100%; color: white; text-align: center;">
                                                  Feedback
                                                </td>
                                              </tr>
                                            </table>

                                            <table style="width: 100%; margin-top: 15px;">
                                              <tr>
                                                <td style="width: 95%; ">
                                                  <mat-form-field  appearance="outline">
                                                    <mat-label>
                                                      <img src="../../assets/img/icones/comentario.png" width="25px">
                                                      Feedback</mat-label>
                                                    <textarea matInput placeholder="Descrição do feedback" rows="5"  style="white-space: pre-line;" formControlName="txFeedback" ></textarea>
                                                  </mat-form-field>
                                                </td>
                                                <!-- <td style="width: 5%; vertical-align: top;">
                                                  <button mat-raised-button  type="button" (click)="atualizarMonitoriaEnviandoCampo('txFeedback')"
                                                      style="background-color: rgb(46, 163, 80); color: #fff; vertical-align: top;
                                                              width: 100%;  font-size: 12px; margin-top: 5px">
                                                          <img src="../../assets/img/icones/salvar.png" width="20px">
                                                    </button>
                                                </td> -->
                                              </tr>
                                            </table>



                                          </mat-card>

                                          <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 8; margin-top: 20px; background-color:rgb(252, 247, 242);" class="mat-elevation-z4">

                                            <table style="width: 100%; background-color: rgb(51, 68, 75); text-align: left;" >
                                              <tr>
                                                <td style="width: 100%; color: white; text-align: center;">
                                                  Avaliado
                                                </td>
                                              </tr>
                                            </table>

                                            <table style="width: 100%; margin-top: 15px;">
                                              <tr>
                                                <td style="width: 95%; ">
                                                  <mat-form-field  appearance="outline">
                                                    <mat-label>
                                                      <img src="../../assets/img/icones/headset.png" width="25px">
                                                      Avaliado</mat-label>
                                                    <textarea matInput style="white-space: pre-line;" rows="5" placeholder="Descrição do Avaliado" formControlName="txAvaliado"></textarea>
                                                  </mat-form-field>
                                                </td>
                                                <!-- <td style="width: 5%; vertical-align: top;">
                                                  <button mat-raised-button  type="button" (click)="atualizarMonitoriaEnviandoCampo('txAvaliado')"
                                                      style="background-color: rgb(46, 163, 80); color: #fff; vertical-align: top;
                                                              width: 100%;  font-size: 12px; margin-top: 5px">
                                                          <img src="../../assets/img/icones/salvar.png" width="20px">
                                                    </button>
                                                </td> -->
                                              </tr>
                                            </table>

                                          </mat-card>

                                          <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 8; margin-top: 20px; background-color:rgb(252, 247, 242);" class="mat-elevation-z4">

                                            <table style="width: 100%; background-color: rgb(51, 68, 75); text-align: left;" >
                                              <tr>
                                                <td style="width: 100%; color: white; text-align: center;">
                                                  Alterações
                                                </td>
                                              </tr>
                                            </table>

                                            <table style="width: 100%; margin-top: 15px;">
                                              <tr>
                                                <td style="width: 95%; ">
                                                  <mat-form-field  appearance="outline">
                                                    <mat-label>
                                                      <img src="../../assets/img/icones/alteracao.png" width="25px">
                                                      Alterações</mat-label>
                                                    <textarea matInput style="white-space: pre-line;" rows="5" placeholder="Descrição das Alterações" formControlName="txAlteracao"></textarea>
                                                  </mat-form-field>
                                                </td>
                                                <!-- <td style="width: 5%; vertical-align: top;">
                                                  <button mat-raised-button  type="button" (click)="atualizarMonitoriaEnviandoCampo('txAlteracao')"
                                                      style="background-color: rgb(46, 163, 80); color: #fff; vertical-align: top;
                                                              width: 100%;  font-size: 12px; margin-top: 5px">
                                                          <img src="../../assets/img/icones/salvar.png" width="20px">
                                                    </button>
                                                </td> -->
                                              </tr>
                                            </table>


                                          </mat-card>

                                          <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 8; margin-top: 20px; background-color:rgb(252, 247, 242);" class="mat-elevation-z4">

                                            <table style="width: 100%; background-color: rgb(51, 68, 75); text-align: left;" >
                                              <tr>
                                                <td style="width: 100%; color: white; text-align: center;">
                                                  Justificativas
                                                </td>
                                              </tr>
                                            </table>

                                            <table style="width: 100%; margin-top: 15px; vertical-align: top;">
                                              <tr>
                                                <td style="width: 25%; vertical-align: top;">
                                                  <mat-form-field  appearance="outline"
                                                                  style="width: 100%; font-size: 12px; text-align: center; font-weight: 500;">

                                                    <mat-label style="text-align: left;">
                                                     <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                     <b> Justificativa</b>
                                                     <i>(Ficha)</i>
                                                   </mat-label>
                                                    <mat-select formControlName="idJustificativa"
                                                          style="text-align: center; font-size: 16px; font-weight: 500;">

                                                      <mat-option *ngFor="let colunas of lstJustificativa; let i = index"  [hidden]="colunas.justDhInativo != null"
                                                            [value]="colunas.justIdCdJustificativa">{{colunas.justDsJustificativa}}
                                                      </mat-option>
                                                    </mat-select>
                                                   </mat-form-field>



                                                </td>
                                                <td style="width: 70%; ">
                                                  <mat-form-field  appearance="outline">
                                                    <mat-label>
                                                      <img src="../../assets/img/icones/justificativa.png" width="25px">
                                                      Descrição para a justificativa</mat-label>
                                                    <textarea matInput style="white-space: pre-line;" placeholder="Descrição da Justificativa"  rows="5" formControlName="txJustificativa"></textarea>
                                                  </mat-form-field>
                                                </td>
                                              </tr>
                                            </table>



                                          </mat-card>

<!--
                                          <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px; margin-bottom: 10px;" class="mat-elevation-z4">
                                            <table style="width: 100%; margin-top: 15px;">
                                              <tr>
                                                <td style="width: 100%; ">

                                                  <img src="../../assets/img/icones/anexoAzul.png" width="25px">&nbsp;&nbsp;
                                                  <img src="../../assets/img/icones/impressora.png" width="25px" onClick="window.print()">&nbsp;&nbsp;

                                                </td>
                                              </tr>
                                            </table>
                                          </mat-card>
                                          -->
                                        </mat-card>

                                        <br/><br/>

                                    </td>

                                  </tr>

                                </table>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>


                    </td>
                </tr>
          </table>

        </div>
      </div>
    </form>
  </div>

</div>
